// Chart Data

export const data = [
    {
      month: 'Jan',
      "Active Rider" : 1000
    },
    {
      month: 'Feb',
      "Active Rider" : 6000
    },
    {
      month: 'Mar',
      "Active Rider" : 5000
    },
    {
      month: 'Apr',
      "Active Rider" : 2000
    },
    {
      month: 'May',
      "Active Rider" : 3000
    },
    {
      month: 'Jun',
      "Active Rider" : 4000
    },
    {
      month: 'Jul',
      "Active Rider" : 10000
    },
    {
      month: 'Agu',
      "Active Rider" : 8000
    },
    {
      month: 'Sep',
      "Active Rider" : 7000
    },
    {
      month: 'Oct',
      "Active Rider" : 1000
    },
    {
      month: 'Nov',
      "Active Rider" : 9000
    },
    {
      month: 'Dec',
      "Active Rider" : 5000
    },

  ];
// Riders Data

export const riderRows = [
  { id: 1, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Snow Jon', age: 35, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 2, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Lannister Cersei', age: 42, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 3, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Lannister Jaime', age: 45, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 4, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Stark Arya', age: 16, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 5, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Sam Afolabi', age: null, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 6, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Melisandre Emma', age: 150, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 7, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Clifford Ferrara', age: 44, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 8, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Frances Rossini', age: 36, email:'info@gmail.com', status: 'active', transactions: '$1000' },
  { id: 9, avatar:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Roxie Harvey', age: 65, email:'info@gmail.com', status: 'active', transactions: '$1000' },
];

// Payment Data
export const paymentRows = [
  { id: 11, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Snow Jon', email:'info@gmail.com', status: 'Approved', transactions: '$1000', date: '29-08-2022' },
  { id: 22, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Lannister Cersei', email:'info@gmail.com', status: 'Approved', transactions: '$1000', date: '29-08-2022' },
  { id: 33, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Lannister Jaime', email:'info@gmail.com', status: 'Declined', transactions: '$1000', date: '29-08-2022' },
  { id: 44, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Stark Arya', email:'info@gmail.com', status: 'Declined', transactions: '$1000', date: '29-08-2022' },
  { id: 55, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Sam Afolabi', email:'info@gmail.com', status: 'Pending', transactions: '$1000', date: '29-08-2022' },
  { id: 66, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Melisandre Emma', email:'info@gmail.com', status: 'Approved', transactions: '$1000', date: '29-08-2022' },
  { id: 77, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Clifford Ferrara', email:'info@gmail.com', status: 'Pending', transactions: '$1000', date: '29-08-2022' },
  { id: 88, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Frances Rossini', email:'info@gmail.com', status: 'Approved', transactions: '$1000', date: '29-08-2022' },
  { id: 99, img:'https://img.icons8.com/external-others-inmotus-design/2x/external-Avatar-man-hair-avatars-others-inmotus-design-10.png', userName: 'Roxie Harvey', email:'info@gmail.com', status: 'Pending', transactions: '$1000', date: '29-08-2022' },
];